import { render, staticRenderFns } from "./PersonGroupShow.vue?vue&type=template&id=a26b22a0&"
import script from "./PersonGroupShow.vue?vue&type=script&lang=js&"
export * from "./PersonGroupShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports